"use strict";

define('config/error',['appkit/configurator', 'bluebird', 'vertebrae', 'rs/error/error.manager', 'rs/errors', 'datakit/ajax'], function (Configurator, Promise, Vertebrae, ErrorManager, RSError, DKAjax) {
  if (!window.production) {
    Promise.longStackTraces();
  }
  var ErrorConfigurator = Configurator.extend({
    onConfigure: function onConfigure() {
      this.app.controllerRegistry.on('controller:error', function (controller, e) {
        ErrorManager.show(e);
      });
      Promise.onPossiblyUnhandledRejection(function (reason, promise) {
        var e = promise.reason(),
          ignored = e instanceof RSError.IgnoredError || e instanceof Vertebrae.App.Errors.NavigationCancelled || e instanceof DKAjax.AbortError;
        if (e && !ignored) {
          ErrorManager.show(e);
        }
        if (!ignored && !window.production) {
          if (e && e.stack) {
            console.log(e.stack);
          } else {
            console.log(reason.stack);
          }
        }
      });
      Promise.onUnhandledRejectionHandled(function (promise) {});
    }
  });
  return ErrorConfigurator;
});

